<template>
  <app-section-wrap :modifier="'login --terms'">
    <div class="card" column="xs-12 s-12 m-8 +m-2">
      <h1
        class="_text-center _mbs"
      >Accept Terms & Conditions</h1>
      <app-terms></app-terms>
      <form @submit.prevent="acceptToc">
        <async-button
          type="submit"
          class=" --sm"
          v-if="!cloudCannonContentLoading"
          :executing="submitting"
        >
          <template #buttonContent>
            <span>accept</span>
          </template>
        </async-button>
      </form>
      <button
        id="reject"
        v-if="!cloudCannonContentLoading"
        class="_mtxs --sm lips"
        @click.prevent="$isSsoUser ? logoutWithSso() : logout()"
      >reject</button>
    </div>
  </app-section-wrap>
</template>
<script>
  import AppSectionWrap from '@molecules/SectionWrap.vue'
  import AppTerms from '@sections/TermsAndConditions.vue'
  import LoginApi from '@api/LoginApi'
  import AsyncButton from '@molecules/AsyncButton.vue'
  import logouttable from '@mixins/logouttable'
  import CloudCannonable from '@mixins/CloudCannonable'

  export default {
    mixins: [logouttable, CloudCannonable],
    components: {
      AppSectionWrap,
      AppTerms,
      AsyncButton
    },
    data() {
      return {
        submitting: false
      }
    },
    methods: {
      acceptToc() {
        this.submitting = true
        console.log('acceptToc !!')
        new LoginApi().acceptTermsAndConditions({})
          .then(resp => {
            this.$store.commit('ACCEPTED_TERMS',true)
            this.$router.push({ name: 'dashboard-prompt' })
          })
          .catch(_ => {
          // todo, do nothing?
          })
      }
    }
  }
</script>
